import { PropsWithChildren, ReactElement } from 'react'
import { SelectTypeAheadController, SelectTypeAheadControllerProps } from 'components/atoms/inputs/SelectTypeAhead/SelectTypeAhead'
import { Omit } from 'interfaces'

const US_STATES = [
  'Alabama (AL)',
  'Alaska (AK)',
  'Arizona (AZ)',
  'Arkansas (AR)',
  'California (CA)',
  'Colorado (CO)',
  'Connecticut (CT)',
  'Delaware (DE)',
  'Florida (FL)',
  'Georgia (GA)',
  'Hawaii (HI)',
  'Idaho (ID)',
  'Illinois (IL)',
  'Indiana (IN)',
  'Iowa (IA)',
  'Kansas (KS)',
  'Kentucky (KY)',
  'Louisiana (LA)',
  'Maine (ME)',
  'Maryland (MD)',
  'Massachusetts (MA)',
  'Michigan (MI)',
  'Minnesota (MN)',
  'Mississippi (MS)',
  'Missouri (MO)',
  'Montana (MT)',
  'Nebraska (NE)',
  'Nevada (NV)',
  'New Hampshire (NH)',
  'New Jersey (NJ)',
  'New Mexico (NM)',
  'New York (NY)',
  'North Carolina (NC)',
  'North Dakota (ND)',
  'Ohio (OH)',
  'Oklahoma (OK)',
  'Oregon (OR)',
  'Pennsylvania (PA)',
  'Rhode Island (RI)',
  'South Carolina (SC)',
  'South Dakota (SD)',
  'Tennessee (TN)',
  'Texas (TX)',
  'Utah (UT)',
  'Vermont (VT)',
  'Virginia (VA)',
  'Washington (WA)',
  'Washington, DC (DC)',
  'West Virginia (WV)',
  'Wisconsin (WI)',
  'Wyoming (WY)',
]

const US_STATES_OPTIONS = US_STATES.map((state) => ({
  label: state,
  value: state.slice(-3).substring(0, 2),
}))

export type SelectUSStatePresetControllerProps<Value> =
  & Omit<SelectTypeAheadControllerProps<Value>, 'options'>
  & {
  }
export const SelectUSStatePresetController = <Value extends any>(props: PropsWithChildren<SelectUSStatePresetControllerProps<Value>>): ReactElement | null => {
  return (
    <SelectTypeAheadController
      { ...props }
      options={ US_STATES_OPTIONS }
    />
  )
}
